module.exports = __webpack_public_path__ + "static/media/slider-l3.ee97086d.webp";